import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import actions from "./actions";

export function* createOrUpdateGift() {
  yield takeEvery(actions.CREATE_OR_UPDATE_GIFT_REQUESTED, function* (action) {
    try {
      const gift = yield call(actions.createOrUpdateGift, action.payload);
      yield put({ type: actions.CREATE_OR_UPDATE_GIFT_SUCCEEDED, gift });
    } catch (error) {
      yield put({
        type: actions.CREATE_OR_UPDATE_GIFT_FAILED,
        error: error.response.data,
      });
    }
  });
}
export default function* rootSaga() {
  yield all([fork(createOrUpdateGift)]);
}
